import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Apple } from "lucide-react";
import White_Logo from "../../src/assets/White_logo.png";

const HamburgerMenu = () => {
    const [open, setOpen] = useState(false);
    const navLinks = [
        { to: "/amii", label: "Home" },
        { to: "/amii/howtouse", label: "Instructions" },
        { to: "/amii/motivations", label: "Motivations" },
    ];
    return (
        <nav className="md:hidden sticky top-2 bg-white text-black shadow-xl z-50 w-[90%] sm:w-11/12 max-w-xl mx-auto rounded-3xl border border-gray-300">
            <div className="flex items-center justify-between px-3 py-2">
                <div className="flex items-center gap-2">
                    <img src={White_Logo} alt="Logo" className="w-10 h-10" />
                    <Link to="/amii" className="text-xl font-bold text-black">
                        Amidex
                    </Link>
                </div>
                <button
                    className="p-2 rounded focus:outline-none focus:ring-2 focus:ring-black/20"
                    onClick={() => setOpen(!open)}
                    aria-label={open ? "Close menu" : "Open menu"}
                >
                    {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
                </button>
            </div>
            {/* Dropdown menu */}
            {open && (
                <div className="px-3 pb-3">
                    <div className="flex flex-col gap-2">
                        {navLinks.map((link) => (
                            <NavLink
                                key={link.to}
                                to={link.to}
                                end
                                className={({ isActive }) =>
                                    `px-4 py-2 rounded-xl transition text-black hover:bg-[#221D23] hover:bg-opacity-20 text-base font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/20 ${isActive ? "bg-gray-200" : ""}`
                                }
                                onClick={() => setOpen(false)}
                            >
                                {link.label}
                            </NavLink>
                        ))}
                        <a
                            href="https://apps.apple.com/us/app/amii-health/id6749024239"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-300 bg-white hover:bg-gray-100 text-base font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/20"
                        >
                            <Apple className="w-4 h-4 text-black" />
                            App Store
                        </a>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default HamburgerMenu;
